// One source of truth for the CPG plan ladder + profile detection, shared by
// Subscribe and Billing so the two pages can never disagree about what a
// brand is offered.

import { Package, TrendingUp, Crown } from 'lucide-react';

export const CPG_TIERS = [
  {
    id: 'cpg',
    name: 'Mise CPG',
    price: 199,
    intro: '$59/mo for your first 3 months',
    description: 'Everything a brand needs to get off the spreadsheets',
    icon: Package,
    features: [
      'PO pipeline — scan, import, open to paid',
      'Distributor invoicing with required wording',
      'Short-pays become deductions automatically',
      'Recipes, ingredient costs & margin per case',
      'Production planning against real demand',
    ],
    popular: true,
  },
  {
    id: 'cpg_growth',
    name: 'CPG Growth',
    price: 299,
    description: 'For brands selling across channels',
    icon: TrendingUp,
    features: [
      'Everything in Mise CPG',
      'Shopify, Faire, Square & QuickBooks connected',
      'Consignment & lot-code tracking',
      'Channel-by-channel revenue view',
      'Priority support',
    ],
    popular: false,
  },
  {
    id: 'cpg_scale',
    name: 'CPG Scale',
    price: 499,
    description: 'For brands with real volume',
    icon: Crown,
    features: [
      'Everything in Growth',
      'White-glove onboarding — we import your trackers',
      'Custom invoice wording & report needs',
      'Direct line for support & requests',
      'Forecast & planning built with you',
    ],
    popular: false,
  },
];

// A maker/brand profile (wholesale or production, no restaurant menu/POS)
// gets the CPG ladder — restaurant tiers price seats and covers they don't have.
export function isCpgProfile(settings: any): boolean {
  const st = settings || {};
  const m = st.modules || {};
  return st.businessKind === 'cpg' || st.businessType === 'cpg'
    || ((m.wholesale === true || m.production === true) && m.menu === false && m.sales !== true);
}
